<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.selectData.workflowId"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.selectData.workflowName"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.pageId"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :customMdList="codes.allOption"
              :customSmdList="codes.selOption"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_USE_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid0"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :hideHeader="true"
        @rowselect="selectWorkflowGrid($event)"
      />
      <div class="mrB30" />
      <sui-grid
        ref="grid1"
        :columns="gridColumns1"
        :dataset="'dataset1'"
        :hideHeader="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onApplyClick"
      >
        {{ $t("MSG_BTN_APPLY") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00006_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    // closePagePopup: {
    //   type: Function,
    // },
    pageId: {
      type: String,
      default: 'PGE_CMR_00006',
    },
    selectWorkflow: {
      type: Function,
    },
  },
  data() {
    return {
      codes: CommonConstants.selectOptions(),
      selectedWorkflowInfo: {},
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_USE_YN: {
            label: '',
            key: '',
          },
          workflowId: '',
          workflowName: '',
        },
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_WKFL_ID'),
        datafield: 'workflowId',
      }, {
        text: this.$t('MSG_TXT_WKFL_NM'),
        datafield: 'workflowName',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
      }],
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_PRC_TASK_STNRD_ID_ITEM_NM'),
        datafield: 'processTaskStandardIdItemName',
      }, {
        text: this.$t('MSG_TXT_PRC_TASK_STNRD_ID'),
        datafield: 'processTaskStandardId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
          }, this.dataset1, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'workflowId',
      type: 'string',
      map: 'workflowId',
    }, {
      name: 'workflowName',
      type: 'string',
      map: 'workflowName',
    }, {
      name: 'moduleName',
      type: 'string',
      map: 'moduleName',
    }, {
      name: 'subModuleName',
      type: 'string',
      map: 'subModuleName',
    }, {
      name: 'workflowExplanationContent',
      type: 'string',
      map: 'workflowExplanationContent',
    }],
  }, {
    id: 'dataset1',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'processTaskStandardIdItemName',
      type: 'string',
      map: 'processTaskStandardIdItemName',
    }, {
      name: 'processTaskStandardId',
      type: 'string',
      map: 'processTaskStandardId',
    }],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      this.frame0.selectData.workflowId = '';
      this.frame0.selectData.workflowName = '';
      this.$refs.smComboFrame0.reset();
      this.$refs.comboUseYn.reset();
    },
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key),
        subModuleCode: utils.trim(codeValue.COD_SMDLE.key),
        workflowUseYn: utils.trim(codeValue.COD_USE_YN.key),
        workflowId: utils.trim(this.frame0.selectData.workflowId),
        workflowName: utils.trim(this.frame0.selectData.workflowName),
      };

      http.request(this.pageId, 'DTS_CMR_00030', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);
      });
    },
    selectWorkflowGrid(target) {
      if (target.args.rowindex !== -1) {
        const selectedRowData = this.dataset0.data[target.args.rowindex];
        this.selectedWorkflowInfo = selectedRowData;
        // console.log(selectedRowData);
        http.request(this.pageId, 'DTS_CMR_00031', {
          path: { 'workflow-id': selectedRowData.workflowId },
        }).then(res => {
          this.localdata1 = res.data;
          this.dataset1.setRawData(this.localdata1);
        });
      }
    },
    onApplyClick() {
      if (this.selectedWorkflowInfo.workflowId) {
        let processTaskStandardId = '';
        this.dataset1.data.forEach(item => {
          if (item.processTaskStandardId) {
            processTaskStandardId += item.processTaskStandardId;
            processTaskStandardId += '|';
          }
        });
        processTaskStandardId = utils.trim(processTaskStandardId, '|');

        this.selectWorkflow({
          workflowId: this.selectedWorkflowInfo.workflowId,
          processTaskStandardId,
          workflowName: this.selectedWorkflowInfo.workflowName,
          workflowExplanationContent: this.selectedWorkflowInfo.workflowExplanationContent,
          moduleName: `${this.selectedWorkflowInfo.moduleName} / ${this.selectedWorkflowInfo.subModuleName}`,
        });
        this.$emit('close');
      }
    },
    onCancelClick() {
      this.$emit('close');
    },
  },

};
</script>
<style scoped>
</style>
